<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_materialCategory') || '物料分类'"
            prop="materialCategory"
          >
            <dict-cascader-category
              v-model="formData.materialCategory"
              :placeholder="
                $l('INDEX.form_placeholder_selectMaterialCategory') ||
                  '请选择物料分类'
              "
              clearable
              filterable
              :show-all-levels="false"
              :sync-codes="true"
              :amzSkuMaterialGroup="amzSkuMaterialGroup"
              @change="onCategoryChange"
            ></dict-cascader-category>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_materialNameCn') || '中文名称'"
            prop="materialName"
          >
            <el-input
              v-model="formData.materialName"
              :placeholder="
                $l('INDEX.form_placeholder_inputMaterialNameCn') ||
                  '请输入中文名称'
              "
              type="text"
              maxlength="50"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_materialNameEn') || '英文名称'"
            prop="materialNameEn"
          >
            <el-input
              v-model="formData.materialNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_inputMaterialNameEn') ||
                  '请输入英文名称'
              "
              type="text"
              maxlength="50"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialDesc') || '材质'"
            prop="materialDesc"
          >
            <el-input
              v-model="formData.materialDesc"
              :placeholder="
                $l('INDEX.form_placeholder_inputMaterialDesc') || '请输入材质'
              "
              type="text"
              maxlength="200"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialSpec') || '规格尺寸'"
            prop="materialSpec"
          >
            <el-input
              v-model="formData.materialSpec"
              :placeholder="
                $l('INDEX.form_placeholder_inputMaterialSpec') ||
                  '请输入规格尺寸'
              "
              type="text"
              maxlength="100"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8"></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_customer') || '所属客户'"
            prop="custCode"
          >
            <dict-select
              :placeholder="
                $l('INDEX.form_placeholder_selectCustomer') || '请选择所属客户'
              "
              size="small"
              clearable
              filterable
              v-model="formData.custCode"
              :selectedLabel.sync="formData.custName"
              :body="custParams"
              url="/master/common/dict/customerSelect"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.form_label_brand') || '所属品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              :selectedLabel.sync="formData.brandName"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_placeholder_selectBrand') || '请选择品牌'
              "
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_customerMaterialNo') || '客户物料编号'"
          >
            <el-input
              v-model="formData.customerMaterialNo"
              :placeholder="
                $l('INDEX.form_placeholder_inputCustomerMaterialNo') ||
                  '请输入客户物料编号'
              "
              type="text"
              maxlength="50"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_materialUnit') || '物料单位'"
            prop="materialUnit"
          >
            <dict-select
              v-model="formData.materialUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'materialUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_isCustomerProvide') || '是否客供'"
          >
            <el-select
              v-model="formData.isCustomerProvide"
              :placeholder="$l('INDEX.form_placeholder_select') || '请选择'"
              style="width: 100%"
              clearable
            >
              <el-option
                :label="$l('INDEX.form_label_yes') || '是'"
                value="Y"
              ></el-option>
              <el-option
                :label="$l('INDEX.form_label_no') || '否'"
                value="N"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_isSpecify') || '是否指定供应商'"
          >
            <el-select
              v-model="formData.isSpecify"
              :placeholder="$l('INDEX.form_placeholder_select') || '请选择'"
              style="width: 100%"
              clearable
            >
              <el-option
                :label="$l('INDEX.form_label_yes') || '是'"
                value="Y"
              ></el-option>
              <el-option
                :label="$l('INDEX.form_label_no') || '否'"
                value="N"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_supplier') || '物料供应商'"
          >
            <dict-select
              :placeholder="
                $l('INDEX.form_placeholder_selectSupplier') ||
                  '请选择物料供应商'
              "
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              :body="scmParams"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('INDEX.form_label_remarks') || '说明'">
            <el-input
              v-model="formData.remarks"
              :placeholder="$l('INDEX.form_placeholder_input') || '请输入'"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
import DictCascaderCategory from '../../../dict-cascader-category/index.vue'

export default {
  components: {
    DictCascaderCategory,
  },
  mixins: [EditLoading],
  props: {
    materialCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
    amzSkuMaterialCode: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      isAdd: false,
      saveMaterialCode: '',
      formData: {
        items: [],
        materialCode: '',
        materialNo: '',
        materialName: '',
        materialNameEn: '',
        productLine: '',
        mainMaterialCategoryCode: '',
        detailMaterialCategoryCode: '',
        materialCategory: '',
        materialDesc: '',
        materialSpec: '',
        custCode: '',
        custName: '',
        brandCode: '',
        brandName: '',
        customerMaterialNo: '',
        isCustomerProvide: 'N',
        isSpecify: 'N',
        scmCode: '',
        remarks: '',
        defaultImageUrl: '',
        materialUnit: '',
      },
      rules: {
        materialUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_materialUnit') || '请选择物料单位',
            trigger: 'blur',
          },
        ],
        materialName: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_inputMaterialName') || '请输入中文名称',
            trigger: 'blur',
          },
        ],
        materialNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_inputMaterialNameCn') || '请输入英文名称',
            trigger: 'blur',
          },
        ],
        materialCategory: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_selectMaterialCategory') || '请选择物料分类',
            trigger: 'change',
          },
        ],
        materialDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_inputMaterialDesc') || '请输入材质',
            trigger: 'blur',
          },
        ],
        materialSpec: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_inputMaterialSpec') || '请输入规格尺寸',
            trigger: 'blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_selectCustomer') || '请选择所属客户',
            trigger: 'change',
          },
        ],
      },
      productLineParams: { dictType: 'productLine' },
      custParams: {},
      brandParams: {},
      scmParams: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      this.reset()

      // 优先使用props中的materialCode
      const materialCode = this.materialCode || this.saveMaterialCode

      if (materialCode) {
        this.$api
          .materialInfoDetailApi({
            materialCode: materialCode,
          })
          .then((res) => {
            this.formData = {
              ...this.formData,
              ...res.body,
            }
            // 设置级联选择器的值（emitPath: false，只需要最后一级的值）
            if (this.formData.detailMaterialCategoryCode) {
              this.formData.materialCategory = this.formData.detailMaterialCategoryCode
            }
            // 触发已加载事件
            this.$emit('loaded', this.formData)
          })
      }
    },
    onCategoryChange(data) {
      this.formData.mainMaterialCategoryCode = data.mainMaterialCategoryCode
      this.formData.detailMaterialCategoryCode = data.detailMaterialCategoryCode
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .ecomAmzSkuMaterialSaveMaterialApi({
          ...this.formData,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
          amzSkuCode: this.amzSkuCode,
          materialOwner: 'ecomAmazon',
        })
        .then((res) => {
          this.loadingClose()
          if (res.status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_saveSuccess') || '保存成功！',
              type: 'success',
            })
            if (this.materialCode) {
              this.$emit('loaded', this.formData)
            } else {
              this.saveMaterialCode = res.body
              this.getData()
            }
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_saveFailed') || '保存失败！')
        })
    },
    reset() {
      this.formData = {
        materialCode: '',
        materialNo: '',
        materialName: '',
        materialNameEn: '',
        productLine: '',
        mainMaterialCategoryCode: '',
        detailMaterialCategoryCode: '',
        materialCategory: '',
        materialDesc: '',
        materialSpec: '',
        custCode: '',
        custName: '',
        brandCode: '',
        brandName: '',
        customerMaterialNo: '',
        isCustomerProvide: 'N',
        isSpecify: 'N',
        scmCode: '',
        remarks: '',
        defaultImageUrl: '',
        materialUnit: '',
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_saveSuccess') || '保存成功',
        this.$l('INDEX.dialog_title_tips') || '提示信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
